import DatetimeUtils from "../../../../../../core/gd/utils/datetime-utils"
import TaskMessage from "../../../../../../core/model2/task-message/task-message"
import ModelEntity from "../../../../../../core/model2/model-entity"
import {EntityType} from "../../../../../../core/gd/const/item"


export default class TaskUpdate extends ModelEntity {

    public momentCreated    : Moment
    public taskMessage      : TaskMessage
    public updateType       : any

    constructor(data:any) {
        super(data.id, EntityType.UPDATE_TASK)

        this.momentCreated      = DatetimeUtils.datetimeToMoment(data['momentCreated'])
        this.taskMessage        = new TaskMessage(data['taskMessage'])
        this.updateType         = data['updateType']
    }
}
